import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from '../notification/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrl: './transactions.component.scss'
})
export class TransactionsComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterFormGroup: FormGroup;
  dataSource: MatTableDataSource<any>;
  fetching: boolean = false;
  displayedColumns: string[] = ['id','timestamp','component_id','component_name','quantity','order_id','order_customer','user','comment'];
  constructor(private http: HttpClient, public dialog: MatDialog, private notificationService: NotificationService) {
    this.dataSource = new MatTableDataSource<any>();
  }

  ngOnInit(): void {
    this.createFilterFormGroup();
    this.fetchTransactions();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  createFilterFormGroup() {
    
    // The default value of 'from' should be two weeks ago
    const twoWeeksAgo = new Date();
    twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);

    this.filterFormGroup =  new FormGroup({
      'from': new FormControl(twoWeeksAgo),
      'to': new FormControl(null)
    });
  }

  getCurrentQueryFilter(): string {
    let filter = '';
    const from = this.filterFormGroup.get('from')?.value;
    const to = this.filterFormGroup.get('to')?.value;
    if(from) {
      filter += `from=${from.toISOString()}&`
    }
    if(to) {
      filter += `to=${to.toISOString()}&`
    }
    return filter
  }

  fetchTransactions() {
    this.fetching = true;
    this.http.get(`transactions?${this.getCurrentQueryFilter()}`).subscribe((response: any) => {
      this.dataSource.data = response;
      this.fetching = false;
    }, error => {
      this.fetching = false;
    })
  }

}
